module.exports = __webpack_public_path__ + "screenshots-stacked.9ba2e499bd4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/marketing/images/screenshots-stacked.png
// module id = ./src/app/marketing/images/screenshots-stacked.png
// module chunks = 21